import {
  DashboardSquare01Icon,
  UserGroupIcon,
  CallingIcon,
  Car05Icon,
  User03Icon,
  Task01Icon,
} from '@hugeicons/core-free-icons';
import { NavItem } from 'svnxii-ng-shared/components';

export const CRM_NAV_ITEMS: NavItem[] = [
  {
    title: 'Dashboard',
    icon: DashboardSquare01Icon,
    route: '/app/crm/dashboard',
  },
  {
    title: 'Potential Customers',
    icon: UserGroupIcon,
    route: '/app/crm/potential-customers',
  },
  {
    title: 'Follow-ups',
    icon: CallingIcon,
    devFeature: true,
    route: '/app/crm/follow-ups',
    isVisible: (baselineKey) =>
      baselineKey === 'AgencyManager' ||
      baselineKey === 'AgencyRepresentative' ||
      baselineKey === 'SalesCommercialManager' ||
      baselineKey === 'SalesSupervisor',
  },
  {
    title: 'Test Drive',
    devFeature: true,
    icon: Car05Icon,
    route: '/app/crm/test-drives',
    isVisible: (baselineKey) =>
      baselineKey === 'AgencyRepresentative' ||
      baselineKey === 'SalesSupervisor' ||
      baselineKey === 'SalesCommercialManager',
  },
  {
    title: 'Surveys',
    icon: Task01Icon,
    route: '/app/crm/surveys',
    // isVisible: (baselineKey) =>
    //   baselineKey === 'AgencyManager' || baselineKey === 'AgencyRepresentative',
  },
  {
    title: 'Account',
    devFeature: true,
    icon: User03Icon,
    route: '/app/crm/notifications',
  },
];
